import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../login/AuthContext';
const ArtisanCreateListingForm = () => {

  const { liveCsrfToken, userId } = useContext(AuthContext); 
  const [formData, setFormData] = useState({
    name: 'product test',
    description: 'description test',
    price: '9',
    designs: [{ design_name: 'Basic test', image_url: '', colors: [] }],
    artisanId:userId,
  });
  const [availableColors, setAvailableColors] = useState([]);
  const [selectedColor, setSelectedColor] = useState(''); // Declare selectedColor state
  const [showAdditionalDesigns, setShowAdditionalDesigns] = useState(false);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE}/api/colors`)
      .then(response => {
        setAvailableColors(response.data);
      })
      .catch(error => {
        console.error('Error fetching colors:', error);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Assuming the CSRF token is stored in your context like before
   
  
    const submitData = {
      ...formData,
      designs: formData.designs.map(design => ({
        ...design,
        image_url: design.image_url ? design.image_url.split(',')[1] : null,
        colors: design.colors.map(color => color.color_id)
      }))
    };
  
    axios.post(`${process.env.REACT_APP_API_BASE}/api/products`, submitData, {
      headers: {
        'x-csrf-token': liveCsrfToken,  // Add CSRF token in headers
      },
      withCredentials: true, // Send session cookie with the request
    })
      .then(response => {
        console.log('Product created:', response.data);
      })
      .catch(error => {
        console.error('Error creating product:', error);
      });
  };
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onloadend = () => {
        resolve(reader.result);
      };
  
      reader.onerror = (error) => {
        reject(error);
      };
  
      reader.readAsDataURL(file);
    });
  };

  const handleImageChange = async (e, index) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const base64Image = await convertToBase64(file);
        const newDesigns = [...formData.designs];
        newDesigns[index].image_url = base64Image;
        setFormData({ ...formData, designs: newDesigns });
      } catch (error) {
        console.error("Error converting image to base64:", error);
      }
    }
  };

  const handleDesignChange = (index, e) => {
    const newDesigns = [...formData.designs];
    newDesigns[index][e.target.name] = e.target.value;
    setFormData({ ...formData, designs: newDesigns });
  };


  const handleColorSelect = (e) => {
    const colorId = e.target.value;
    const color = availableColors.find(c => c.color_id.toString() === colorId);
    setSelectedColor(color);
  };

  const addColorToDesign = (designIndex) => {
    if (!selectedColor) return;
    const updatedDesigns = formData.designs.map((design, index) => {
      if (index === designIndex && !design.colors.find(c => c.color_id === selectedColor.color_id)) {
        return {
          ...design,
          colors: [...design.colors, selectedColor]
        };
      }
      return design;
    });
    setFormData({ ...formData, designs: updatedDesigns });
  };

  const addDesign = () => {
    setFormData({
      ...formData,
      designs: [...formData.designs, { design_name: '', image_url: '', colors: [] }]
    });
  };
  const toggleAdditionalDesigns = () => {
    setShowAdditionalDesigns(!showAdditionalDesigns);
  };



  return (
    <form onSubmit={handleSubmit}>
      <label>
        Product Name:
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
      </label>
      <label>
        Description:
        <textarea
          name="description"
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
        />
      </label>
      <label>
        Price:
        <input
          type="number"
          name="price"
          value={formData.price}
          onChange={(e) => setFormData({ ...formData, price: e.target.value })}
        />
      </label>
      {formData.designs.map((design, index) => (
        <div key={index}>
          {index === 0 || showAdditionalDesigns ? (
            <>
              <label>
                Variation Name:
                <input
                  type="text"
                  name="design_name"
                  value={design.design_name}
                  onChange={(e) => handleDesignChange(index, e)}
                />
              </label>
              <label>
            Image:
            <input
  type="file"
  accept="image/*"
  onChange={(e) => handleImageChange(e, index)} // Pass the index
/>
          </label>
          {design.image_url && (
            <img src={design.image_url} alt="Preview" style={{ width: '100px', height: '100px' }} />
          )}
              <div>
            <select onChange={handleColorSelect}>
              <option value="">Select a color</option>
              {availableColors.map((color) => (
                <option key={color.color_id} value={color.color_id}>{color.color_name}</option>
              ))}
            </select>
            <button type="button" onClick={() => addColorToDesign(index)}>+</button>
            <ul>
              {design.colors.map((color, colorIndex) => (
                <li key={colorIndex} style={{ color: color.color_hex_code }}>
                  {color.color_name}
                  <span style={{ backgroundColor: color.color_hex_code, display: 'inline-block', width: '20px', height: '20px', borderRadius: '50%' }}></span>
                </li>
              ))}
            </ul>
          </div>
            </>
          ) : null}
        </div>
      ))}
      {showAdditionalDesigns ? (
        <button type="button" onClick={addDesign}>Add Another Design</button>
      ) : (
        <button type="button" onClick={toggleAdditionalDesigns}>
          Add Variation
        </button>
      )}

      <button type="submit">Submit</button>
    </form>
  );
};

export default ArtisanCreateListingForm;
